// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  
  update(ctx, model) {
    return new Promise((resolve, reject) => {
        NewApiService.post("product-stocks/"+model.productId, model)
        .then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
            reject(response)
        });
    });
  },

  move(ctx, model) {
    return new Promise((resolve, reject) => {
        NewApiService.post("product-stocks/"+model.productId+"/move", model)
        .then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
            reject(response)
        });
    });
  },

};
